import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

export const query = graphql(`
    query LearningPathActivityReportQuery($id: ID!, $pwd: String!) {
        learningPathActivityReport(id: $id, pwd: $pwd) {
            id
            version
            name
            data
            createdDatetime
            people {
                id
                firstName
                lastName
            }
            learningPath {
                id
                name
                pathname
            }
        }
    }
`);

export type ILearningPath = NonNullable<ResultOf<typeof query>["learningPathActivityReport"]>["learningPath"];
